import React, { useState, useEffect } from 'react'
import { Drawer } from 'antd'
import logo from 'image/logo_icon.png'
import moment from 'moment'
import Icon from 'meinian-package/src/component/icon'
import CreateOrEditChildIdeaMass from 'meinian-package/src/component/createOrEditChildIdeaMass'
import { request, auth as userAuth } from 'meinian-package/src/utils'
import { ossImg } from 'meinian-package/src/utils/image'
import './index.less'
import Button from 'meinian-package/src/baseComponent/button'
import EditIdeaMass from '../editIdeaMass'

/**
 * @description: 灵感集详情，（有编辑权限可编辑）
 * @return {*}
 */

export default function LookLgjDetail(props) {
  const { inspirationId, parentId, currentInfo = [], onChange, onDelete, isChild, style, className, children, onClick } = props
  const [info, setInfo] = useState(currentInfo)
  const auth = info?.loginUserInfo?.inspirationPermissions || []
  const currentRole = info?.loginUserInfo?.role
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (visible) {
      fetchInfo()
    }
  }, [visible])

  const onClose = (e) => {
    e && e.stopPropagation()
    setVisible(false)
  }

  const onClickTrigger = (e) => {
    e && e.stopPropagation()
    setVisible(true)
    onClick && onClick()
  }

  const fetchInfo = async () => {
    if (inspirationId) {
      try {
        const _info = await request.get('/zhikuan/ins/inspiration/get-inspiration-info', { params: { inspirationId } })
        setInfo(_info)
      } catch (error) {
        console.error('fetchInfo', error)
      }
    }
  }

  return (
    <div onClick={e => e.stopPropagation()}>
      <span onClick={onClickTrigger} style={style} className={className}>{children || '灵感集详情'}</span>
      <Drawer
        className="looklgjdetail"
        placement="left"
        closable={false}
        onClose={onClose}
        visible={visible}
        width="480"
        bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column' }}
      >
        <div className="looklgjdetail-info-header">
          <div className="title">灵感集详情</div>
        </div>
        <div className="looklgjdetail-info-context">
          { ((info?.coverImgUrl || (info?.lastBlogList && info?.lastBlogList[0]))) ? <div style={{ backgroundImage: `url(${ossImg(info?.coverImgUrl || ((info?.lastBlogList && info?.lastBlogList?.length) ? info?.lastBlogList[0]?.mainUrl : ''), 244)})` }} className="cover-1" />
            : <div className="cover-1 empty"><img src={logo} /></div>}
          <div className="looklgjdetail-text">
            <div className="looklgjdetail-text-title">
              {info?.name}
            </div>
            {info?.introduction ? <div className="looklgjdetail-item">
              <div className="item-title">简介</div>
              <div className="item-right">
                <div className="info-introduction line-2">{info?.introduction}</div>
              </div>
            </div> : null}
            {info?.tagNameList?.length ? <div className="looklgjdetail-item">
              <div className="item-title">标签</div>
              <div className="item-right">
                <div className="looklgjdetail-text-tab">
                  {info?.tagNameList?.map((tag) => { return <span key={tag}>{tag}</span> })}
                </div>
              </div>
            </div> : null}
            <div className="looklgjdetail-line" />
            <div className="looklgjdetail-item" style={{ marginBottom: 4 }}>
              <div className="item-title">创建者</div>
              <div className="item-right">
                <div className="looklgjdetail-text-user">
                  <img src={info?.creator?.avatar} />
                  <span className="looklgjdetail-user-name">{info?.creator?.userName}</span>
                  <span style={{ marginLeft: '12px', color: 'var(--m-text-3)' }}>{moment(info?.createdAt).format('YYYY/MM/DD')} 创建</span>
                </div>
              </div>
            </div>
            <div className="looklgjdetail-item" style={{ marginBottom: 4 }}>
              <div className="item-title">拥有者</div>
              <div className="item-right">
                <div className="looklgjdetail-text-user">
                  <img src={info?.ownerAvatar} />
                  <span className="looklgjdetail-user-name">{info?.ownerName}</span>
                  <span style={{ marginLeft: '12px', color: 'var(--m-text-3)' }}>{moment(info?.ownerTime).format('YYYY/MM/DD')} 拥有</span>
                </div>
              </div>
            </div>
            <div className="looklgjdetail-item">
              <div className="item-title">更新信息</div>
              <div className="item-right">
                <div className="looklgjdetail-text-user">
                  <img src={info?.creator?.avatar} />
                  <span className="looklgjdetail-user-name">{info?.creator?.userName}</span>
                  <span style={{ marginLeft: '12px', color: 'var(--m-text-3)' }}>{moment(info?.updatedAt).format('YYYY/MM/DD')} 编辑</span>
                </div>
              </div>
            </div>
            <div className="looklgjdetail-line" />
            {info?.markerList?.length ? <div className="looklgjdetail-item">
              <div className="item-title">审核者</div>
              <div className="item-right">
                <OpenEditIdeaMass
                  isChild={isChild}
                  parentId={parentId}
                  inspirationId={info.id}
                  onChange={onChange}
                  onDelete={onDelete}
                  auth={auth}
                  currentRole={currentRole}
                  mode={2}
                >
                  <div className="looklgjdetail-people-list" onClick={() => setVisible(false)}>
                    {info.markerList.map((item, index) => { return index < 3 && `${item.userName}${(index < 2 || (index === 2 && info.markerList.length === 3)) ? '；' : ''}` })}
                    {info.markerList.length > 3 ? <span>等{info.markerList.length}人<Icon type="m-Vxing_you" /></span> : ''}
                  </div>
                </OpenEditIdeaMass>
              </div>
            </div> : null}
            {info?.userList?.length ? <div className="looklgjdetail-item">
              <div className="item-title">协作人</div>
              <div className="item-right">
                <OpenEditIdeaMass
                  isChild={isChild}
                  parentId={parentId}
                  inspirationId={info.id}
                  onChange={onChange}
                  onDelete={onDelete}
                  auth={auth}
                  currentRole={currentRole}
                  mode={2}
                >
                  <div className="looklgjdetail-people-list" onClick={() => setVisible(false)}>
                    {info.userList.map((item, index) => { return index < 3 && `${item.userName}${(index < 2 || (index === 2 && info.userList.length === 3)) ? '；' : ''}` })}
                    {info.userList.length > 3 ? <span>等{info.userList.length}人<Icon type="m-Vxing_you" /></span> : ''}
                  </div>
                </OpenEditIdeaMass>
              </div>
            </div> : null}
            {info?.relatedShop ? <div className="looklgjdetail-item">
              <div className="item-title">相关店铺</div>
              <div className="item-right dfc">
                <a className="abbreviation" style={{ color: 'var(--m-text-2)' }} href={info.relatedShop} target="_blank" rel="noreferrer">{info.relatedShopName}</a>
                <Icon type="m-Vxing_you" />
              </div>
            </div> : null}
            {info?.relatedInspiration ? <div className="looklgjdetail-item">
              <div className="item-title">相关灵感集</div>
              <div className="item-right dfc">
                <a className="abbreviation" style={{ color: 'var(--m-text-2)' }} href={info.relatedInspiration} target="_blank" rel="noreferrer">{info.relatedInspirationName}</a>
                <Icon type="m-Vxing_you" />
              </div>
            </div> : null}
            {userAuth.hasInspirationAuth(isChild, auth, ['F03', 'FC04', 'FC04_CREATOR']) ? <div className="looklgjdetail-footer">
              <OpenEditIdeaMass
                isChild={isChild}
                parentId={parentId}
                inspirationId={info?.id}
                onChange={onChange}
                onDelete={onDelete}
                auth={auth}
                currentRole={currentRole}
              >
                <Button type="primary" onClick={() => setVisible(false)}>编辑</Button>
              </OpenEditIdeaMass>
            </div> : null}
          </div>
        </div>
      </Drawer>
    </div>
  )
}

const OpenEditIdeaMass = ({ children, isChild, parentId, inspirationId, onChange, onDelete, auth, currentRole, mode = 1 }) => {
  return (isChild ? <CreateOrEditChildIdeaMass
    isCreate={false}
    auth={auth}
    currentRole={currentRole}
    parentId={parentId}
    inspirationId={inspirationId}
    onChange={onChange}
    onDelete={onDelete}
  >
    <div>{children}</div>
  </CreateOrEditChildIdeaMass>
    : <EditIdeaMass
        mode={mode}
        currentRole={currentRole}
        auth={auth}
        parentId={parentId}
        inspirationId={inspirationId}
        onChange={onChange}
        onDelete={onDelete}
    ><div>{children}</div>
    </EditIdeaMass>)
}
